<template>
    <toolbar-option>
        <template slot="primary">
            <button-group
                :value="value"
                :options="options"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'align-self',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Alignment',
            tailwindDefinitionProp: 'alignSelf',
            value: '',
        };
    },

    computed: {
        options() {
            const parentElement = this.selectedElements[0].$el.parentNode;
            const parentFlexDirection = this.getComputedValue('flex-direction', parentElement);

            if (parentFlexDirection === 'column') {
                return [
                    { text: 'Left', value: 'start' },
                    { text: 'Center', value: 'center' },
                    { text: 'Right', value: 'end' },
                ];
            }

            return [
                { text: 'Top', value: 'start' },
                { text: 'Middle', value: 'center' },
                { text: 'Bottom', value: 'end' },
            ];
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'placement') this.onConflict();
        },
    },

    methods: {
        onInput(newValue) {
            let flexClassNew;

            if (newValue) {
                flexClassNew = this.addFlexClass({
                    value: newValue,
                });
            } else {
                this.removeFlexClass();
            }

            this.value = newValue;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.value;
        },

        onConflict() {
            this.removeFlexClass();
            this.value = '';
        },
    },
};
</script>
